import actionCreatorFactory from "typescript-fsa";
import { asyncFactory, thunkToAction } from "typescript-fsa-redux-thunk";
import api from "../api";
import { State } from "../state";
import { Preferences } from "./types";

const create = actionCreatorFactory("Preferences");

const createAsync = asyncFactory<State>(create);

export const getUserPreferences = createAsync<{}, Preferences>(
  "GET_USER_PREFERENCES",
  async (params, dispatch, getState) => {
    return await api.preferences.getUserPreferences();
  }
);

const getUserPreferencesAction = thunkToAction(getUserPreferences.action);
export type GetUserPreferencesActionType = typeof getUserPreferencesAction;

export const getSupportedLanguages = createAsync<{}, string[]>(
  "GET_SUPPORTED_LANGUAGES",
  async (params, dispatch, getState) => {
    return await api.preferences.getSupportedLanguages();
  }
);

const getSupportedLanguagesAction = thunkToAction(getSupportedLanguages.action);
export type GetSupportedLanguagesActionType = typeof getSupportedLanguagesAction;

export const saveUserPreferences = createAsync<{}, Preferences>(
  "UPDATE_USER_PREFERENCES",
  async (params, dispatch, getState) => {
    return await api.preferences.saveUserPreferences(params);
  }
);

const saveUserPreferencesAction = thunkToAction(saveUserPreferences.action);
export type SaveUserPreferencesActionType = typeof saveUserPreferencesAction;



// WEBPACK FOOTER //
// ./src/preferences/actions.ts